import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PdfLessonView = ({ lesson }) => {
  const [embedFailed, setEmbedFailed] = useState(false);

  if (!lesson?.fileUrl) {
    return (
      <div className="bg-white/70 backdrop-blur-xl rounded-2xl border border-white/40 shadow-sm p-12 text-center">
        <div className="w-12 h-12 rounded-full bg-muted/70 flex items-center justify-center mx-auto mb-3">
          <Icon name="File" size={20} className="text-muted-foreground" />
        </div>
        <p className="text-muted-foreground text-sm">No file has been added to this lesson yet.</p>
      </div>
    );
  }

  return (
    <div className="bg-white/70 backdrop-blur-xl rounded-2xl border border-white/40 shadow-sm overflow-hidden">
      {!embedFailed ? (
        <iframe
          src={lesson?.fileUrl}
          title={lesson?.title}
          className="w-full aspect-[4/5] sm:aspect-video border-0"
          onError={() => setEmbedFailed(true)}
        />
      ) : (
        <div className="p-12 text-center">
          <div className="w-12 h-12 rounded-full bg-muted/70 flex items-center justify-center mx-auto mb-3">
            <Icon name="File" size={20} className="text-muted-foreground" />
          </div>
          <p className="text-muted-foreground text-sm mb-4">This PDF can't be previewed here.</p>
        </div>
      )}
      <div className="p-4 border-t border-border/60 flex justify-center bg-muted/20">
        <a href={lesson?.fileUrl} target="_blank" rel="noopener noreferrer">
          <Button variant="outline" iconName="ExternalLink" iconPosition="left">
            Open PDF in New Tab
          </Button>
        </a>
      </div>
    </div>
  );
};

export default PdfLessonView;